import React, { useState } from 'react';
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import './activity-calendar.scss';
import { Button, Popover } from '@material-ui/core';
import moment from 'moment';

const ActivityDatePicker = ({ dateRange, setDateRange }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [tempRange, setTempRange] = useState([
    {
      startDate: dateRange?.startDate || new Date(),
      endDate: dateRange?.endDate || new Date(),
      key: 'selection',
    },
  ]);

  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setTempRange([
      {
        startDate: dateRange?.startDate || new Date(),
        endDate: dateRange?.endDate || new Date(),
        key: 'selection',
      },
    ]);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setDateRange({
      startDate: tempRange[0]?.startDate,
      endDate: tempRange[0]?.endDate,
    });
    setAnchorEl(null);
  };

  const onCancelOverlay = () => {
    setTempRange([
      {
        startDate: dateRange?.startDate || new Date(),
        endDate: dateRange?.endDate || new Date(),
        key: 'selection',
      },
    ]);
    setAnchorEl(null);
  };

  const formatDateDisplay = () => {
    const start = dateRange?.startDate;
    const end = dateRange?.endDate;
    if (start && end) {
      return `${moment(start).format('DD/MM/YYYY')} - ${moment(end).format('DD/MM/YYYY')}`;
    }
    return 'Select Date Range';
  };

  return (
    <div>
      <Button
        className={!open ? 'activity-date-range-picker' : 'activity-date-range-picker-clicked'}
        variant='outlined'
        color='secondary'
        size='medium'
        startIcon={
          <img
            className='mb-1 ms-2'
            src={'./assets/icons/dashboard/date-range.svg'}
            alt={'date-range'}
          />
        }
        onClick={handleClick}
      >
        {formatDateDisplay()}
      </Button>

      <Popover
        id={'activity-date-range-popover'}
        open={open}
        anchorEl={anchorEl}
        onClose={onCancelOverlay}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        PaperProps={{
          style: {
            maxWidth: 'fit-content',
          },
        }}
        className='pointer activity-date-range-popover'
      >
        <DateRangePicker
          onChange={(item) => setTempRange([item?.selection])}
          showSelectionPreview={true}
          moveRangeOnFirstSelection={false}
          months={2}
          ranges={tempRange}
          direction='horizontal'
          rangeColors={['#29E67C']}
        />
        <div className='activity-date-range-btn-wrapper d-flex'>
          <Button variant='outlined' className='cancel-btn' size='medium' onClick={onCancelOverlay}>
            Cancel
          </Button>
          <Button
            variant='contained'
            size='medium'
            className='apply-btn'
            onClick={handleClose}
          >
            Apply
          </Button>
        </div>
      </Popover>
    </div>
  );
};

export default ActivityDatePicker;
